import PropTypes from 'prop-types';
import classNames from 'classnames';
import VibeIcon from '../VibeIcon/VibeIcon';
import * as color from '../../sass/color.scss';
import './RadioField.scss';

function RadioField({
  className = '',
  style = {},
  icon = null,
  iconPlacement = 'left',
  label,
  value = null,
  description = null,
  selected = false,
  disabled = false,
  readOnly = false,
  onClick = () => {},
}) {
  const onClickField = () => {
    onClick(value ?? label);
  };

  const iconHtml = (
    <VibeIcon
      icon={icon}
      color={selected
        ? color.obsidian
        : color.gray700}
      // hoverColor={color.obsidian}
      size={16}
    />
  );

  return (
    <div
      className={classNames('RadioField', className, { selected, disabled, 'read-only': readOnly })}
      style={style}
      onClick={disabled || readOnly
        ? null
        : onClickField}
    >
      {!readOnly && (
        <div className={classNames('radio-circle', { selected })} />
      )}

      <div className="radio-info">
        <div className="radio-title">
          {icon && iconPlacement === 'left' && iconHtml}

          {label}

          {icon && iconPlacement === 'right' && iconHtml}
        </div>

        {description && (
          <div className="description">
            {description}
          </div>
        )}
      </div>
    </div>
  );
}

RadioField.propTypes = {
  /** Custom class */
  className: PropTypes.string,
  style: PropTypes.object,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  description: PropTypes.string,
  /** Is the field selected */
  selected: PropTypes.bool.isRequired,
  /** Is the field disabled */
  disabled: PropTypes.bool,
  icon: PropTypes.func,
  /** Is the field read only (no radio icon) */
  readOnly: PropTypes.bool,
  onClick: PropTypes.func,
};

export default RadioField;
